import variables from '../../styles/colors.module.scss';

const { white, blue, graylight: grayLight } = variables;

export const STYLES = {
    DEFAULT_BLUE_COLOR: blue,
    DEFAULT_UNFILLED_PROGRES_COLOR: grayLight,
    WHITE: white,
};

export const KEY_CODE = {
    ENTER_CODE: 13,
    SPACEBAR_CODE: 32,
};

export const EVENT_LISTENERS = {
    LOADED_META_DATA: 'loadedmetadata',
    TIME_UPDATE: 'timeupdate',
    ENDED: 'ended',
    BLUR: 'blur',
    FOCUS: 'focus',
};

export const ONE_HUNDRED_PERCENT = 100;
